<template>
  <section class="newsletter-section">
    <div class="newsletter-content">
      <div class="newsletter-title-row">
        <v-icon color="#ffcc80" size="28">mdi-email-newsletter</v-icon>
        <h2>Newsletter</h2>
      </div>
      <p>
        A free weekly ish newsletter: remote dev jobs, tech visa updates, career
        insights, and trusted resources, designed for people navigating their
        path in tech.
      </p>
      <p v-if="$route.query.target" class="unlock-note">
        Subscribe to unlock the free AI resource link you clicked.
      </p>

      <form class="signup-form" @submit.prevent="handleSubmit">
        <v-textarea
          v-model="email"
          class="email-input"
          placeholder="your@email.com"
          rows="1"
          auto-grow
          hide-details="auto"
          variant="outlined"
          bg-color="white"
          :error-messages="errorMessage"
        ></v-textarea>

        <div class="button-row">
          <v-btn type="submit" class="subscribe-btn" :loading="isSubmitting">
            Subscribe
          </v-btn>
        </div>
      </form>
      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "NewsletterSignup",
  data() {
    return {
      email: "",
      errorMessage: "",
      successMessage: "",
      isSubmitting: false,
      beehiivSubscribeUrl: "https://aishainsweden.gumroad.com/",
    };
  },
  methods: {
    handleSubmit() {
      this.errorMessage = "";
      this.successMessage = "";

      const emailTrimmed = this.email.trim();
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(emailTrimmed)) {
        this.errorMessage = "Please enter a valid email address.";
        return;
      }

      window.localStorage.setItem("newsletterSubscribed", "true");
      window.localStorage.setItem("newsletterSubscribedEmail", emailTrimmed);

      if (this.beehiivSubscribeUrl.includes("PASTE_YOUR_BEEHIIV")) {
        this.successMessage =
          "You are unlocked. Add your Beehiiv subscribe URL to activate your live signup flow.";

        const targetUrl = this.$route.query.target;
        if (targetUrl) {
          window.open(targetUrl, "_blank", "noopener");
        }
        return;
      }

      this.isSubmitting = true;
      const subscribeUrl = `${
        this.beehiivSubscribeUrl
      }?email=${encodeURIComponent(emailTrimmed)}`;
      window.location.href = subscribeUrl;
    },
  },
};
</script>

<style scoped>
.newsletter-section {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  padding: 1.5rem 1.6rem;
  backdrop-filter: blur(8px);
  animation: fadeInUp 2s ease;
  margin-top: 1.25rem;
}

.newsletter-content {
  max-width: 900px;
}

.newsletter-title-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.5rem;
}

.newsletter-title-row h2 {
  color: white;
  font-size: 1.35rem;
  font-weight: 700;
  margin: 0;
}

.newsletter-section p {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1rem;
  line-height: 1.65;
  margin-bottom: 1rem;
}

.signup-form {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  align-items: center;
  margin-bottom: 0.75rem;
}

.email-input {
  width: 100%;
  max-width: 560px;
}

.button-row {
  display: flex;
  justify-content: center;
  width: 100%;
}

.subscribe-btn {
  min-width: 180px;
  text-transform: none;
  font-weight: 600;
  color: #ffffff;
  background-color: #007f8c;
  text-align: center;
  border-radius: 999px;
  letter-spacing: 0.3px;
  box-shadow: 0 10px 24px rgba(0, 127, 140, 0.28);
}

.subscribe-btn:hover {
  background-color: #006c76;
}

.success-message {
  color: #d7ffd7;
  font-size: 0.9rem;
  margin-top: -0.25rem;
}

.newsletter-note {
  font-size: 0.85rem !important;
  color: rgba(255, 255, 255, 0.7) !important;
  margin-bottom: 0 !important;
}

.unlock-note {
  color: #ffecb3 !important;
  font-weight: 600;
}

@media (max-width: 640px) {
  .subscribe-btn {
    width: min(100%, 320px);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
